<template>
  <a-modal
    v-model="visible"
    :title="modalTitle"
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_save')"
    :width="700"
    @ok="formSubmit"
    @cancel="formReset"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    destroyOnClose
    centered
  >
    <a-form-model
      :model="form"
      :rules="formRules"
      ref="modelUpdate"
      :label-col="{ span: 7 }"
      :wrapper-col="{ span: 14 }"
    >
      <!-- 型号 -->
      <a-form-model-item :label="$t('deviceModel_form_model_name')" prop="name">
        <a-input
          v-model="form.name"
          :placeholder="$t('deviceModel_form_model_name_placeholder')"
          allowClear
          @input="formInput"
          ref="formName"
        />
      </a-form-model-item>

      <!-- 父模型 -->
      <a-form-model-item :label="$t('deviceModel_form_parent_model')" prop="parentId">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="form.parentId"
          show-search
          :placeholder="
            formType === 'edit' || formType === 'fork'
              ? ''
              : $t('deviceModel_form_parent_model_placeholder')
          "
          style="width:380px"
          :filter-option="filterOption"
          allowClear
          :disabled="formType === 'edit' || formType === 'fork'"
        >
          <a-select-option
            v-for="parentModel in parentModelList"
            :key="parentModel.devModelId"
            :value="parentModel.devModelId"
          >
            {{ parentModel.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- avatar -->
      <a-form-model-item :label="$t('deviceModel_form_avatar')" prop="avatar">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="form.avatar"
          :placeholder="
            formType === 'edit' || formType === 'fork'
              ? ''
              : $t('deviceModel_form_avatar_placeholder')
          "
          style="width:380px;"
          allowClear
        >
          <a-select-option
            v-for="item in deviceAvatarList"
            :key="item.value"
            :value="item.value"
            style="display: flex; align-items: center;"
          >
            <span style="display: flex; align-items: center;">
              <DeviceAvatar :avatarType="item.value" style="width:16px;height:16px;" />
              <span>{{ item.value }} </span>
            </span>
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- SSH -->
      <a-form-model-item :label="$t('deviceModel_form_support_ssh')" prop="supportSsh">
        <a-switch v-model="form.supportSsh" />
      </a-form-model-item>

      <!-- WEB -->
      <a-form-model-item :label="$t('deviceModel_form_support_web')" prop="supportWeb">
        <a-switch v-model="form.supportWeb" />
      </a-form-model-item>

      <!-- 模型图片 -->
      <a-form-model-item :label="$t('deviceModel_form_model_image')" prop="icons">
        <UploadOSS
          :value="form.icons"
          :manuallyUpload="false"
          @change="
            fileList => {
              form.icons = fileList || [];
            }
          "
          :maxCount="1"
          ref="uploadFile"
          uploadDirInOSS="images"
          uploadType="image"
        />
      </a-form-model-item>

      <!-- 描述 -->
      <a-form-model-item :label="$t('com_form_description')" prop="description" style="margin:0">
        <a-textarea
          v-model="form.description"
          :placeholder="$t('com_form_description_placeholder')"
          :rows="5"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>
    </a-form-model>
    <!-- 错误描述 -->
    <div class="form-error-text">
      <Icon type="error" v-if="formError" />
      <p>{{ formError }}</p>
    </div>
  </a-modal>
</template>
<script>
import * as API from '@/api/system/model';
import deviceAvatarList from '@/config/deviceAvatar';

export default {
  props: {
    parentModelList: {
      type: Array,
      default: () => [],
    },

    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      deviceAvatarList,
      modelInfo: null,

      // 新增
      visible: false,
      formRules: {
        name: [
          {
            required: true,
            message: this.$t('deviceModel_form_model_name_placeholder'),
            trigger: 'change',
          },
        ],
      },

      // 搜索
      form: {
        name: undefined,
        parentId: undefined,
        supportSsh: false,
        supportWeb: false,
        icons: undefined,
        description: undefined,
        avatar: undefined,
      },

      formError: '',
      formType: '',
      formLoading: false,
    };
  },
  computed: {
    modalTitle() {
      if (this.formType === 'fork') {
        return this.$t('deviceMode_model_fork_title');
      } else if (this.formType === 'edit') {
        return this.$t('deviceMode_model_edit_title');
      } else {
        return this.$t('deviceMode_model_add_title');
      }
    },
  },
  methods: {
    // 父模型过滤
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    // 更新列表
    updateList() {
      // 更新列表，如果是编辑则传回ID
      this.callback && this.callback(this.formType === 'edit' ? this.modelInfo.devModelId : '');
    },

    // 显示
    show(type, record) {
      this.visible = true;
      this.formType = type || 'add';
      this.formError = '';
      this.modelInfo = record;

      // focus name
      this.$nextTick(() => {
        this.$refs.formName && this.$refs.formName.focus();
        this.formReset();

        // 编辑
        if (this.formType === 'edit' || this.formType === 'fork') {
          this.form = {
            name: record.name,
            parentId: record.parentId || undefined,
            supportSsh: record.supportSsh,
            supportWeb: record.supportWeb,
            description: record.description,
            icons: record.icons,
            avatar: record.avatar,
          };

          // 处理父模型如果已经删除
          if (
            record.parentId &&
            !this.parentModelList.map(item => item.devModelId).includes(record.parentId)
          ) {
            this.form.parentId = undefined;
          }
        }
      });
    },

    // 提交
    formSubmit() {
      this.$refs.modelUpdate.validate(valid => {
        if (valid) {
          this.formLoading = true;

          const params = { ...this.form };

          // 指定字段，格式化两边的空格
          for (const key in params) {
            if (['supportSsh', 'supportWeb'].includes(key)) {
              params[key] = !!this.form[key];
            }
          }

          if (this.formType === 'fork') {
            // fork
            params.forkModelId = this.modelInfo.devModelId;
            API.DeviceModelFork(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_fork_success'));
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          } else if (this.formType === 'edit') {
            // 编辑
            params.devModelId = this.modelInfo.devModelId;
            API.DeviceModelEdit(params)
              .then(res => {
                if (res.code === 0) {
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          } else {
            // 添加
            API.DeviceModelAdd(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_add_success'));
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //  - error reset
    formInput() {
      this.formError = '';
    },
    //  - add form reset
    formReset() {
      this.$refs.modelUpdate.resetFields();

      this.form = {
        parentId: undefined,
        name: undefined,
        icons: undefined,
        description: undefined,
        avatar: undefined,
      };
    },
  },
};
</script>
<style lang="less" scoped>
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}

::v-deep .ant-form-item {
  margin-bottom: 10px;
}
</style>
